import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import {
  Table, Grid, Box, Button, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow,
  TableHead, Paper, Typography
} from "@material-ui/core";
import MainHeading from "../../components/MainHeading";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ListAltOutlinedIcon from '@material-ui/icons/ListAltOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import DateTimePicker from "../../components/DateComponent";
import clsx from "clsx";
import { Controller, FormContext, useForm } from "react-hook-form";
import { default as Apiservices } from "../../common";
import SOTable from "./components/Table/salesOrderTable";
import InvoiceTable from "./components/Table/invoiceTable";
import DashboardTableComponent from "./components/Table/masterJobsTable";
import "../../themes/css/list-view.css";
import LinearScaleOutlinedIcon from '@material-ui/icons/LinearScaleOutlined';
import MoneyOutlinedIcon from '@material-ui/icons/MoneyOutlined';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined';
import Notifications from "../../components/Notifications";
import DoneAllOutlinedIcon from '@material-ui/icons/DoneAllOutlined';
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import SvgIcon from "@material-ui/core/SvgIcon";
import AutocompleteController from "../../components/AutocompleteController";
import FormValidationErrorMessage from "../../components/FormValidationErrorMessage";

function Rupee(props) {
  return (
    <SvgIcon {...props} viewBox="0 -50 203.86 400">
      <g id="Group_21638" data-name="Group 21638"><path id="Path_26915" data-name="Path 26915" class="cls-1" d="M135.76,28.35H185L203.86,0h-185L0,28.35H32.1c32.5,0,62.5,2.5,74.51,29.7H19L.15,86.39h110c0,20.4-16.9,51.65-72.8,51.65h-27v26.5L118.74,300H167L54.85,160c46.15-2.5,89.46-28.31,95.7-73.56H185L203.86,58.1h-53.8a62.85,62.85,0,0,0-14.3-29.75Z" /></g>
    </SvgIcon>
  );
}

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: "100%",
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  paper1: {
    background: "#fff",
  },
  container: {
    maxHeight: "218px",
    minHeight: "218px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
        // border: "3px solid orange",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
  subTextButton: {
    fontWeight: '600',
    wordBreak: 'break-word',
    //color:"#adbfcd",
    [theme.breakpoints.only('xs')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('sm')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('md')]: {
      fontSize: '12px !important',
    },
    [theme.breakpoints.only('lg')]: {
      fontSize: '14px !important',
    },
    [theme.breakpoints.only('xl')]: {
      fontSize: '20px !important',
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,

  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function Dashboard(props) {
  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [dashBoardDetails, setDashboardDetails] = useState({});
  const [dashboardTableDetails, SetDashboardTableDetails] = useState([]);
  const [branchMasterList, setBranchMasterList] = useState([])
  // let array = [{ invoicedate: "1", count: "1" }];
  const [array, setArray] = React.useState([
    { invoicedate: "No Data", count: "No Data" },
  ]);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const dashboardResponse = await Apiservices.getDashboardData();
      console.log(dashboardResponse, "dashboardResponse")
      if (dashboardResponse) {
        setDashboardDetails(dashboardResponse)
      }
      debugger;
      const listBranchResponse = await Apiservices.listBranchMaster()
      console.log(listBranchResponse, "listBranchResponse")
      if (listBranchResponse && listBranchResponse.length > 0) {
        setBranchMasterList(listBranchResponse)
      }
    }
    fetchData();
  }, []);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, array.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const methods = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    // defaultValues,
  });

  const dummyValues = [
    { label: 'option1', value: 'option1' },
    { label: 'option2', value: 'option2' },
    { label: 'option3', value: 'option3' },
  ]
  console.log(dashBoardDetails.job_data, "job_data in dashboard")

  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
    validateform,
  } = methods;

  const handleSearchByDates = async () => {
    let formData = methods.getValues({ nest: true })
    if (formData.start_date || formData.end_date) {
      let params = {}
      if (formData.branch) {
        params.start_date = formData.start_date && formData.start_date;
        params.end_date = formData.end_date && formData.end_date;
        params.branch = formData.branch && formData.branch.value
      } else {
        params.start_date = formData.start_date && formData.start_date;
        params.end_date = formData.end_date && formData.end_date;
      }

      let dahsboardDataResponse = await Apiservices.getDashboardData(params && params);
      setDashboardDetails(dahsboardDataResponse)
    }
  }

  const handleFilterByBranch = async () => {
    let formData = methods.getValues({ nest: true })
    let isBranchSelected = methods.triggerValidation([`branch`])
    console.log(errors, "errors")
    if (isBranchSelected) {
      let branchName =
        formData.branch && formData.branch.label
          ? formData.branch.label
          : formData.branch;
      const params = {
        branch: branchName
      }
      let dahsboardDataResponse = await Apiservices.getDashboardData(params && params);
      setDashboardDetails(dahsboardDataResponse)
    } else {
      setNotify({
        isOpen: true,
        message: `Please Select Branch`,
        type: "error",
        timing: 3000,
      });
    }
  }

  const getJobsCount = (vertical) => {
    let infoObj = dashBoardDetails.vertical_info && dashBoardDetails.vertical_info.find(item => item.vertical === vertical)
    return infoObj && infoObj.jobs_confirmed ? infoObj.jobs_confirmed : 0
  }

  const getJobsOpsCount = (vertical) => {
    let infoObj = dashBoardDetails.vertical_info && dashBoardDetails.vertical_info.find(item => item.vertical === vertical)
    return infoObj && infoObj.in_progress ? infoObj.in_progress : 0
  }

  console.log(dashBoardDetails.vertical_info && dashBoardDetails.vertical_info.find(item => item.vertical == "Sea Import"), "vertical info")
  //  dashBoardDetails.vertical_info.map(item => item.vertical == "Sea Import").jobs_confirmed

  return (
    <div>
      <MainHeading
        title={"Dashboard"}
      />
      <Box py={1}>
        <Paper elevation={0}>
          <Box p={3}>
            <Grid item container spacing={2}>
              <Grid item xs={12} sm={3}>
                <AutocompleteController
                  Values={branchMasterList}
                  name="branch"
                  control={control}
                  required={false}
                  rules={{ required: true }}
                  label="Branch"
                  disabled={false}
                  getValueChanged={(data) => {
                  }}
                  error={errors.branch}
                />
                {errors.branch && (
                  <FormValidationErrorMessage
                    errors={errors}
                    errorMessagePrefix="Branch"
                    name="branch"
                  />
                )}
              </Grid>
             
              <Grid item >
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(
                    classes.subTextButton,
                    "btnMinWidthSearch"
                  )}
                  onClick={handleFilterByBranch}
                  disabled={false}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
      <Box py={2} >
        <Grid container
          direction="row"
         
          alignItems="stretch" spacing={2}>
          <Grid item xs={12} sm={3}>
            <Paper className="height100 grOne">
              <Box p={1} >
                <Grid container spacing={1}>
                  <Grid item sm>
                    <Box pb={1}>
                      <p className="dashboardHeading">Jobs Confirmed</p>
                    </Box>
                    <p className="dashboardNumber">
                      {dashBoardDetails && dashBoardDetails.jobs_confirmed_count && dashBoardDetails.jobs_confirmed_count}
                    </p>
                  </Grid>
                  <Grid item>
                    <Box >
                      <AddBoxOutlinedIcon className="dashboardIconOne dashboardIcon" />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Paper className="height100 grTwo">
              <Box p={1} >
                <Grid container spacing={1}>
                  <Grid item sm>
                    <Box pb={1}>
                      <p className="dashboardHeading">In Progress</p>
                    </Box>
                    <p className="dashboardNumber">
                      {dashBoardDetails && dashBoardDetails.jobs_in_progress && dashBoardDetails.jobs_in_progress}
                    </p>
                  </Grid>
                  <Grid item>
                    <Box >
                      <ReceiptOutlinedIcon className=" dashboardIcon dashboardIconThree" />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>

        </Grid>
      </Box>

      <Box py={2} >
        <Grid container
          direction="row"
          justifyContent="center"
          alignItems="stretch" spacing={2}>
          <Grid item xs={12} sm={3}>
            <Paper className="height100 grFour">
              <Box p={1} >
                <Grid container spacing={1}>
                  <Grid item sm>
                    <Box pb={1}>
                      <Typography>
                        <p className="dashboardVertical">Sea Import</p>
                      </Typography>

                    </Box>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Box >
                          <p className="dashboardHeading">Jobs Confirmed</p>
                        </Box>
                        <p className="dashboardNumber">
                          {getJobsCount("Sea Import")}
                        </p>
                      </Grid>

                      <Grid item xs={6}>
                        <Box >
                          <p className="dashboardHeading">Jobs InProgress</p>
                        </Box>
                        <p className="dashboardNumber">
                          {getJobsOpsCount("Sea Import")}
                        </p>
                      </Grid>


                    </Grid>

                  </Grid>

                </Grid>
              </Box>
            </Paper>
          </Grid>


          <Grid item xs={12} sm={3}>
            <Paper className="height100 grThree">
              <Box p={1} >
                <Grid container spacing={1}>
                  <Grid item sm>
                    <Box pb={1}>
                      <Typography>
                        <p className="dashboardVertical">Air Import</p>
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box >
                        <p className="dashboardHeading">Jobs Confirmed</p>
                      </Box>
                      <p className="dashboardNumber">
                        {getJobsCount("Air Import")}
                      </p>
                    </Grid>

                    <Grid item xs={6}>
                      <Box >
                        <p className="dashboardHeading">Jobs InProgress</p>
                      </Box>
                      <p className="dashboardNumber">
                        {getJobsOpsCount("Air Import")}
                      </p>
                    </Grid>


                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Paper className="height100 grFour">
              <Box p={1} >
                <Grid container spacing={1}>
                  <Grid item sm>
                    <Box pb={1}>
                      <Typography>
                        <p className="dashboardVertical">Sea Export</p>
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box >
                        <p className="dashboardHeading">Jobs Confirmed</p>
                      </Box>
                      <p className="dashboardNumber">
                        {getJobsCount("Sea Export")}
                      </p>
                    </Grid>

                    <Grid item xs={6}>
                      <Box >
                        <p className="dashboardHeading">Jobs InProgress</p>
                      </Box>
                      <p className="dashboardNumber">
                        {getJobsOpsCount("Sea Export")}
                      </p>
                    </Grid>


                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Paper className="height100 grThree">
              <Box p={1} >
                <Grid container spacing={1}>
                  <Grid item sm>
                    <Box pb={1}>
                      <Typography>
                        <p className="dashboardVertical">Air Export</p>
                      </Typography>
                    </Box>

                  </Grid>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Box >
                        <p className="dashboardHeading">Jobs Confirmed</p>
                      </Box>
                      <p className="dashboardNumber">
                        {getJobsOpsCount("Air Export")}
                      </p>
                    </Grid>

                    <Grid item xs={6}>
                      <Box >
                        <p className="dashboardHeading">Jobs InProgress</p>
                      </Box>
                      <p className="dashboardNumber">
                        {getJobsOpsCount("Air Export")}
                      </p>
                    </Grid>


                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>

        </Grid></Box>

      <Box py={1}>
        <Paper elevation={0}>
          <Box p={3}>
            <Grid item container spacing={2}>
              <Grid item xs={12} sm={3}>
                <DateTimePicker
                  label="From Date"
                  name={`start_date`}
                  defaultValue={null}
                  required={false}
                  disabled={false}
                  control={control}
                  methods={methods}
                  rules={{ required: false }}
                />
                {errors.start_date && (
                  <FormValidationErrorMessage
                    errors={errors}
                    errorMessagePrefix="Start Date"
                    name="start_date"
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={3}>
                <DateTimePicker
                  label="To Date"
                  name={`end_date`}
                  defaultValue={null}
                  required={false}
                  disabled={false}
                  control={control}
                  methods={methods}
                  error={errors.end_date}
                  rules={{ required: false }}
                />
                {errors.end_date && (
                  <FormValidationErrorMessage
                    errors={errors}
                    errorMessagePrefix="End Date"
                    name="end_date"
                  />
                )}
              </Grid>
              <Grid item >
                <Button
                  variant="contained"
                  color="primary"
                  className={clsx(
                    classes.subTextButton,
                    "btnMinWidthSearch"
                  )}
                  onClick={handleSearchByDates}
                  disabled={false}
                >
                  Search
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
      <Box py={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box pt={1}>
              <h4 className={classes.secondHeading}>{"Sales Orders Created"}</h4>
            </Box>
            <SOTable
              data={dashBoardDetails && dashBoardDetails.so_data && dashBoardDetails.so_data}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box pt={1}>
              <h4 className={classes.secondHeading}>{"Invoices Created"}</h4>
            </Box>
            <InvoiceTable
              data={dashBoardDetails && dashBoardDetails.invoice_data && dashBoardDetails.invoice_data}
            />
          </Grid>
        </Grid>
      </Box>
      <Box py={1}>
        <Box py={1}>
          <h4 className={classes.secondHeading}>{"Master Job Details"}</h4>
        </Box>

        <DashboardTableComponent
          data={dashBoardDetails && dashBoardDetails.job_data && dashBoardDetails.job_data}
        />
      </Box>
    </div>
  );
}


